import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styles from './DummyCounter.module.scss'

const DummyCounter = (props) => {
  const { height = 48, isError = false } = props
  const [focused, setFocused] = useState(false)

  const value = props.value !== undefined ? props.value : 0

  const incrementDisabled =
    props.disabled || (props.max !== undefined && value >= props.max)
  const decrementDisabled =
    props.disabled || (props.min !== undefined && value <= props.min)

  const onChangeHandler = (val) => {
    if (props.onChange && !props.disabled) {
      if (props.min !== undefined) val = Math.max(val, props.min)
      if (props.max !== undefined) val = Math.min(val, props.max)
      if (!isNaN(val)) {
        props.onChange(
          props.fixed ? +val.toFixed(props.fixed) : val,
          props.name,
        )
      }
    }
  }

  const getValue = () =>
    props.value !== undefined
      ? props.fixed
        ? +props.value.toFixed(props.fixed)
        : props.value
      : ''

  return (
    <div
      className={`${styles.counterBox} ${
        props.disabled ? styles.counterBoxDisabled : ''
      } ${focused ? styles.counterBoxFocused : ''} ${
        isError ? styles.counterBoxError : ''
      }`}
      style={{ height: `${height}px` }}
    >
      <div
        className={`${styles.button} ${
          decrementDisabled ? styles.disabledButton : ''
        }`}
        onClick={() => {
          if (!decrementDisabled) {
            onChangeHandler(value - (props.step || 1))
          }
        }}
      >
        -
      </div>
      <input
        type='text'
        value={getValue()}
        className={props.disabled ? styles.disabledInput : ''}
        onChange={(e) => onChangeHandler(+e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
      <div
        className={`${styles.button} ${
          incrementDisabled ? styles.disabledButton : ''
        }`}
        onClick={() => {
          if (!incrementDisabled) {
            onChangeHandler(value + (props.step || 1))
          }
        }}
      >
        +
      </div>
    </div>
  )
}

DummyCounter.propTypes = {
  name: PropTypes.string,
  value: PropTypes.number,
  onChange: PropTypes.func,
  step: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  fixed: PropTypes.number,
  disabled: PropTypes.bool,
  isError: PropTypes.bool,
  height: PropTypes.number,
}

export default DummyCounter
